import { Container, Typography, Paper, Grid } from '@mui/material';
import { Helmet } from 'react-helmet';
import StaticPageLayout from '../components/layout/StaticPageLayout';

export default function About() {
  return (
    <StaticPageLayout>
      <Helmet>
        <title>About ET-Business - Leading Ethiopian Business Directory Platform</title>
        <meta name="description" content="Learn about ET-Business, Ethiopia's premier business directory platform. Discover our mission to connect Ethiopian businesses with customers, our comprehensive listing services, and our commitment to supporting local business growth." />
      </Helmet>

      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper sx={{ p: 4, borderRadius: '12px' }}>
              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Ethiopia's Premier Business Directory Platform
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, color: '#444', lineHeight: 1.8 }}>
                ET-Business is Ethiopia's leading online business directory platform, dedicated to connecting local businesses with potential customers across the nation. Our comprehensive directory showcases diverse businesses from various sectors, making it easier for people to discover and connect with the services they need.
              </Typography>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Our Mission
              </Typography>
              <Typography variant="body1" sx={{ mb: 4, color: '#444', lineHeight: 1.8 }}>
                Our mission is to empower Ethiopian businesses by providing them with a robust online presence and connecting them with customers seeking their products and services. We strive to be the bridge between businesses and consumers, facilitating growth and development in Ethiopia's business landscape.
              </Typography>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                What We Offer
              </Typography>
              <Grid container spacing={4} sx={{ mb: 4 }}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" sx={{ mb: 2, color: '#3A551A' }}>
                    For Businesses
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#444', lineHeight: 1.8 }}>
                    We provide businesses with a powerful platform to showcase their services, reach potential customers, and grow their online presence. Our directory listings include detailed business information, contact details, and location data, making it easy for customers to find and connect with businesses.
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" sx={{ mb: 2, color: '#3A551A' }}>
                    For Customers
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#444', lineHeight: 1.8 }}>
                    Customers can easily search and discover businesses across Ethiopia, access verified contact information, and find detailed information about services offered. Our platform features user-friendly search filters, categorized listings, and location-based search capabilities.
                  </Typography>
                </Grid>
              </Grid>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Our Coverage
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: '#444', lineHeight: 1.8 }}>
                ET-Business covers businesses across all major Ethiopian cities, including:
              </Typography>
              <Grid container spacing={2} sx={{ mb: 4 }}>
                <Grid item xs={12} sm={6} md={4}>
                  <Paper sx={{ p: 2, bgcolor: '#F5F7FA', borderRadius: '8px' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#3A551A' }}>
                      Addis Ababa
                    </Typography>
                    <Typography variant="body2">The capital and primary business hub</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Paper sx={{ p: 2, bgcolor: '#F5F7FA', borderRadius: '8px' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#3A551A' }}>
                      Dire Dawa
                    </Typography>
                    <Typography variant="body2">Major industrial center</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Paper sx={{ p: 2, bgcolor: '#F5F7FA', borderRadius: '8px' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#3A551A' }}>
                      Bahir Dar
                    </Typography>
                    <Typography variant="body2">Northwestern commercial center</Typography>
                  </Paper>
                </Grid>
              </Grid>

              <Typography variant="h5" sx={{ color: '#3A551A', mb: 3, fontWeight: 600 }}>
                Join ET-Business
              </Typography>
              <Typography variant="body1" sx={{ color: '#444', lineHeight: 1.8 }}>
                Whether you're a business owner looking to expand your reach or a customer searching for reliable services, ET-Business is your gateway to Ethiopia's business community. Join our platform today to be part of Ethiopia's growing digital business ecosystem.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </StaticPageLayout>
  );
} 